import QRCode from 'assets/qr-code.svg';
import Download from 'icons/Download';
import 'app/styles/cv.css';

const CV = () => (
  <div className="cv">
    <main>
      <h1>Gleb H.</h1>
      <h2>Software Engineer</h2>
      <hr />
      <div className="contact-info">
        <div>
          Email:
          {' '}
          <a href="mailto:glebhusky@gmail.com">glebhusky@gmail.com</a>
        </div>
        <div>
          LinkedIn:
          {' '}
          <a href="https://www.linkedin.com/in/gleb-husky">
            https://www.linkedin.com/in/gleb-husky
          </a>
        </div>
        <div>
          GitHub:
          {' '}
          <a href="https://github.com/glebhusky">https://github.com/glebhusky</a>
        </div>
      </div>
      <img className="qr-code" src={QRCode} alt="QR Code to CV" />
      <a href="cv/download" className="download" target="_blank" rel="noopener noreferrer">
        <div>Download</div>
        <Download />
      </a>
      <h3>Skills</h3>
      <p>
        <span className="bold">Backend:</span>
        {' '}
        <span>Node.js, Ruby on Rails</span>
        <br />
        <span className="bold">Frontend:</span>
        {' '}
        <span>React, TypeScript</span>
        <br />
        <span className="bold">Misc:</span>
        {' '}
        <span>PostgreSQL, Redis, Kafka, Docker, AWS, Kubernetes, New Relic, Datadog</span>
      </p>
      <h3>Work Experience</h3>
      <p>
        <span className="bold">Oct 2020 - Present</span>
        {' '}
        <span>
          Fullstack Software Engineer at
          {' '}
          <a href="https://www.doctolib.de">Doctolib</a>
        </span>
        <ul>
          <li>
            Optimized multiple backend and frontend features to improve performance under high load
          </li>
          <li>Reduced P95 latency of core endpoints by 20%</li>
          <li>
            Led development of an internal tool,
            {' '}
            cutting technical support handling time per task by 50%
          </li>
          <li>Mentored 6 engineers in Ruby on Rails and onboarded multiple new team members</li>
        </ul>
        <span className="bold">
          Stack: Ruby on Rails, React, TypeScript, PostgreSQL, AWS, Datadog
        </span>
      </p>
      <p>
        <span className="bold">Apr 2017 - Sep 2020</span>
        {' '}
        <span>
          Fullstack Software Engineer at
          {' '}
          <a href="https://www.fahrstundenplaner.de">fahrstundenplaner.de</a>
        </span>
        <ul>
          <li>Developed a management system for driving schools</li>
          <li>Migrated legacy frontend to React</li>
        </ul>
        <span className="bold">
          Stack: Node.js, React, Redux, PostgreSQL, GraphQL, Docker, AWS, New Relic
        </span>
      </p>
      <p>
        <span className="bold">Apr 2016 - Apr 2017</span>
        {' '}
        <span>Fullstack Software Engineer at FirstFinance</span>
        <ul>
          <li>Implemented redesigns for multiple e-commerce websites</li>
          <li>Optimized websites for mobile devices</li>
        </ul>
        <span className="bold">Stack: PHP, Javascript, HTML, CSS</span>
      </p>
      <h3>Projects</h3>
      <p>
        <span>DieDasDer - a language-learning app for practicing German noun articles</span>
        <br />
        <a href="https://diedasder.app">https://diedasder.app</a>
        <br />
        <span className="bold">Stack: Node.js, React, PostgreSQL, Jest, Playwright</span>
      </p>
      <h3>Education</h3>
      <p>
        <span className="bold">Oct 2014 - Feb 2020</span>
        {' '}
        <span>Freie Universität Berlin. Bachelor of Computer Science.</span>
      </p>
      <h3>Languages</h3>
      <ul>
        <li>English (fluent)</li>
        <li>German (fluent)</li>
        <li>Russian (native)</li>
      </ul>
    </main>
  </div>
);

export default CV;
